import { render, staticRenderFns } from "./TipoCargoProfesorComponent.vue?vue&type=template&id=76a0466e"
import script from "./TipoCargoProfesorComponent.vue?vue&type=script&lang=js"
export * from "./TipoCargoProfesorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports